import { Pipe, PipeTransform } from '@angular/core';
import { AsYouType } from 'libphonenumber-js';
import { config as config } from 'src/config/config';
@Pipe({
  name: 'phoneNumberFormat',
})
export class PhoneNumberFormatPipe implements PipeTransform {
  readonly config = config;
  static forRoot():
    | any[]
    | import('@angular/core').Type<any>
    | import('@angular/core').ModuleWithProviders<{}> {
    throw new Error('Method not implemented.');
  }
  constructor() {}
  transform(value: any, countryCode: any): string {
    let countryName: any = '';
    if (!(value || countryCode)) return '';
    if (countryCode === config.COUNTRIES.US.COUNTRY_CODE) {
      countryName = config.COUNTRIES.US.COUNTRY_NAME;
    }
    let asYouType = new AsYouType(countryName);
    asYouType.reset();
    return asYouType.input(value);
  }
}
